export const VOTE_STATUS = {
	CAN_NOT_VOTE: 'CAN_NOT_VOTE',
	CAN_VOTE: 'CAN_VOTE',
	VOTED: 'VOTED',
};
